import React, { forwardRef, useEffect, useState, useContext } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { MdLogout } from 'react-icons/md';
import ModeNightIcon from '@mui/icons-material/ModeNight';
import LightModeIcon from '@mui/icons-material/LightMode';
import { FaUserAlt } from 'react-icons/fa';
import Badge from '@mui/material/Badge';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';

import { IconContext } from "react-icons";
import { useLocation } from "react-router-dom";

import GroupAdd from '@mui/icons-material/GroupAdd';


import logo from '../../image/logo.svg'
import logoBlack from '../../image/logoBlack.png'
import patter from '../../image/patterColorido.svg'
import photo from '../../image/photo.png'
import sino from '../../image/sino.png'
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import notifica from '../../image/notifica.png'
import dark from '../../image/dark.png'
import HomeIcon from '@mui/icons-material/Home';

import './style.css'
import { getFirebase, getTheme, getUsuarioCargoId, getUsuarioSetorId, logout } from '../../services/auth';
import api from '../../services/api';
import { IconButton } from '@mui/material';
import { atendimetoWhatsapp } from '../../function';
import { ThemeContext } from '../../contexts/theme-context';

function Header({history, avatar, user, showNotify, notificacao, setNotificacao, idContrato, setShowUsuarios}) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [setorId, setSetorId] = useState(0);
    const location = useLocation();
    let [home , setHome] = useState(false);
    useEffect(() => {
        let url = process.env.NODE_ENV !== 'development' ? process.env.PUBLIC_URL : '';
        if(location.pathname !== (url+ '/solucoes')){
            setHome(true);
        }
    }, [location.pathname])
    const [themeHeaders , setThemeHeaders] = useState(getTheme());
    const logoff = () => {
        let tokenFire = getFirebase()
        api.post(`/clients/token`,{
            token: tokenFire,
            '_method': "delete"
        }).then(function (response) {
        }).catch(function(error){
            console.log(error)
        });
        logout();
        history.push('login');
    }
    const WhatsApp = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HelpOutlineIcon
                className="iconCenter"
                style={{
                    width: 30,
                    height: 50,
                    marginRight: 20
                }}/>
            </div>
        );
    });
    const Faq = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HeadsetMicIcon 
                    className="iconCenter"
                    style={{
                        width: 30,
                        height: 50,
                        marginRight: 20
                    }}
                />
            </div>
        );
    });
    const Home = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HomeIcon 
                    className="iconCenter"
                    style={{
                        width: 30,
                        height: 50
                    }}
                />
            </div>
        );
    });
    const newAttendance = async () => {
        // logNavegacao('atendimento', 'whatsapp');
        let data = {
            id: idContrato,
            cnpj: user.cnpj,
            nome: user.name,
            endereco: user.endereco,

        }
        let msg = "Solicito atendimento \n contrato: " + data.id + "\n";
        msg+= 'CPF/CNPJ: ' + data.cnpj;
        msg+= ' \nNome: ' + data.nome;
        msg+= ' \nEndereco: ' + data.endereco;
        atendimetoWhatsapp(msg);
    }
    const fac = async () => {
        let url =  "https://www.grupourbam.com.br/contato/fale-conosco";
        window.open(url, '_blank', 'noreferrer');
    }
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    useEffect(() => {
        setInterval(myTimer ,1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const fetchSetorAndCargoId = () => {
    try {
        const usuarioSetorId = getUsuarioSetorId();
        setSetorId(usuarioSetorId/1);
    } catch (error) {
        console.error("Erro ao buscar setor:", error);
    }
    };
    useEffect(() => {
        fetchSetorAndCargoId();
    }, [])
    let [relogio, setRelogio] = useState();  
    let [saudacao, setSaudacao] = useState();  
    function myTimer() {
        var d = new Date(), displayDate;
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            displayDate = d.toLocaleDateString('pt-BR', {timeZone: 'America/Belem'}) + " " + d.toLocaleTimeString('pt-BR');
        } else {
            displayDate = d.toLocaleDateString('pt-BR', {timeZone: 'America/Belem'}) + " " + d.toLocaleTimeString('pt-BR', {timeZone: 'America/Belem'});
        }
       setRelogio(displayDate);
       greetingMessage(d)
    }
    const greetingMessage = (d) => {
        let h = new Date().getHours();
        if (h < 12){
            setSaudacao('Bom dia')
        }else{
            if (h < 18) {
                setSaudacao('Boa tarde')
            }else{
                setSaudacao('Boa noite');
            }
        }
    }
    const changeTheme = () => {
        let themeTemp = 'light';
        if(themeHeaders === 'light'){
            themeTemp = 'dark';
        }
        setThemeHeaders(themeTemp);
        toggleTheme()
    }
    return (
        <>
            <Navbar className='nav' expand="lg"  variant="dark" fixed="top">
                <Container>
                    <div style={{
                        marginLeft: 35, 
                        cursor: "pointer"
                        }}
                        onClick={() => history.push('home')}>
                        <Navbar.Brand>
                            <img
                            src={theme !== 'dark' ? logo : logoBlack}
                            className="d-inline-block align-top logoHeader"
                            alt="Grupo Urbam Logo"
                            />
                        </Navbar.Brand>
                    </div>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text className='box2'>
                            <div style={{color: "var(--main-white-color)"}}>
                            
                            </div>
                        </Navbar.Text>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text className='box2'>
                            <div style={{color: "var(--main-white-color)"}}>
                                {user.contratoColeta + " - " + user.nameContrato}
                            </div>
                        </Navbar.Text>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        <div className='boxmenu'>    
                            {/* <div 
                            className='box2' 
                            style={{
                                margin: 10, 
                                marginLeft: 10, 
                                marginRight: 20, 
                                cursor: 'pointer'
                            }}
                            onClick={handleClick}
                            aria-controls={open ? 'alert-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}>
                                <Badge badgeContent={user.quantidadeEmAberto} color="error" max={9}>
                                    <img
                                    src={sino}
                                    height="22"
                                    className="d-inline-block align-top"
                                    alt="icon sino"
                                    />
                                </Badge>
                            </div>
                             */}
                            <Nav
                                className="boxmenu"
                                >
                                    <Navbar.Text className='box2'>
                                        {/* <IconButton aria-label="Theme" onClick={changeTheme}>
                                            {themeHeaders === 'light' ? 
                                                <ModeNightIcon sx={{ color: "var(--main-white-color)" }} />
                                                :
                                                <LightModeIcon sx={{ color: "var(--main-white-color)" }} />
                                            }
                                        </IconButton> */}
                                        {avatar ? (
                                            <img
                                            src={photo}
                                            height="52"
                                            className="d-inline-block align-top"
                                            alt="Avatar"
                                            />
                                        ):(
                                            <div style={{
                                                backgroundColor: "var(--main-white-color-50)", 
                                                padding: 6, 
                                                width: 52, 
                                                height: 52, 
                                                borderRadius: 52, 
                                                display: "flex", 
                                                justifyContent: 'center', 
                                                alignItems: 'center'
                                            }}
                                            >
                                                <IconContext.Provider value={{ size: 25, color: "var(--main-white-color)" }} >
                                                    <FaUserAlt  />
                                                </IconContext.Provider>
                                            </div>
                                        )}
                                        <div style={{color: "var(--main-white-color)", marginLeft: 10}}>
                                            {user.name}
                                        </div>
                                        {/* {((setorId === 1) || (setorId === 2)) && (
                                            <IconButton aria-label="Usuarios" onClick={() => setShowUsuarios(true)} style={{marginLeft: 40}}>
                                                <GroupAdd  sx={{ color: "var(--main-white-color)" }}   />
                                            </IconButton>
                                        )} */}
                                        <div style={{marginRight: 5,}}>
                                            {home && (
                                                <Badge badgeContent={notificacao} color="error" max={9} overlap="circular">
                                                    <IconButton aria-label="Notificações" onClick={() => {
                                                        showNotify(true);
                                                        setNotificacao(0);
                                                    }}>
                                                        <MailOutlineIcon sx={{ color: "var(--main-white-color)" }} />
                                                    </IconButton>
                                                </Badge>
                                            )}
                                        </div>
                                        <IconButton aria-label="Logout" onClick={logoff}>
                                            <LogoutIcon sx={{ color: "var(--main-white-color)" }} />
                                        </IconButton>
                                    </Navbar.Text>
                            </Nav>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Navbar className='nav2' expand="lg" style={{padding: 0, top: 84}} sticky="top">
                <div className='box backgroundPatter'>
                    <div className='saudacao'>{saudacao}</div>
                    <div className='dataHora'>{relogio}</div>
                    <div style={{
                        height: 50,
                        position: "absolute",
                        width: "100%",
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="FAQ">
                            <WhatsApp onClick={() => fac()} />
                        </Tooltip>
                        <Tooltip title="Atendimento" onClick={() => newAttendance()}>
                            <Faq />
                        </Tooltip>
                        {!home && (
                            <Tooltip title="Home" onClick={() =>  history.push('home')}>
                                <Home />
                            </Tooltip>
                        )}
                        
                    </div>
                </div>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <img
                        src={patter}
                        className="d-inline-block align-top patterInvert"
                        style={{height: 60}}
                        alt="Patter"
                        />
                    </Navbar.Text>
                </Navbar.Collapse>
            </Navbar>
            <Menu
                anchorEl={anchorEl}
                id="alert-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                    },
                    '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    },
                },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <FeedbackIcon fontSize="small" />
                    </ListItemIcon>
                    Existe {user.quantidadeEmAberto} faturas em aberto!
                </MenuItem>
            </Menu>
        </>
    );
}

export default Header;